<template>
  <div>
    <van-nav-bar
      fixed
      placeholder
      left-text="返回"
      left-arrow
      right-text="儲存"
      :title="title"
      @click-left="cmdBack"
      @click-right="cmdRight"
    >
    </van-nav-bar>
  </div>
</template>
<style scoped>
.navbar {
  position: fixed;
  width: 100%;
  color: yellow;
  top: 0;
  height: 3.6rem;
  line-height: 3.6rem;
  background-color: blue;
}
.h-x4 {
  height: 4rem;
}
</style>

<script>
// @ is an alias to /src

export default {
  components: {},
  props: {
    title: String,
  },
  data() {
    return {};
  },
  methods: {
    cmdBack() {
      window.location.href = "/";
    },
    cmdRight(){
      this.$emit("rightClick");
    }
  },
};
</script>
